export default {
  title: "",
  subtitle: "Enable and Disable Webhooks",
  path: "webhooks_enable_and_disable",
  paragraph: "For enabling a webhook, you’ll need to register your own URL to receive notifications from FacilitaPay. You can use the following endpoint to enable the webhooks:",
  request: {
    method: "POST",
    endpoint: "/enable_webhooks",
    payloads: [
      {
       title: "After registering it, you'll receive a 'secret', a value that will be posted along with the notification information for authenticity check. See the sample below:",
       content:{
        "url": "https://your-url-for-listening-to-webhooks.com"
       }
      }
    ],
  responses: {
      "data": {
        "secret": "3718"
      }
    }
  },
  parameterPayload: [
    {
      name: "url",
      type: "string",
      required: true,
      description: "Url to receive notifications from the api"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/EnableDisableWebhooks.js